module.exports = __webpack_public_path__ + "img/popup-3_mob.5512142c.webp";